import request from '@/utils/request'

const api = {
  Query(data) {
    return request({
      url: '/admin/log/list',
      method: 'post',
      data
    })
  }
}
export default api
